import { v4 } from '@lukeed/uuid';
import { DatumKind } from '../../../constants/SignalsKinds';
import { get2DSpectrumErrorValue } from './get2DSpectrumErrorValue';
import { getShift } from './getShift';
import { isZoneExists } from './isZoneExists';
function getSignal(signal, shiftTarget, shift) {
    const { x, y } = signal;
    if (shiftTarget === 'origin') {
        return {
            ...signal,
            x: {
                ...x,
                originalDelta: x.delta - shift.x,
            },
            y: {
                ...y,
                originalDelta: y.delta - shift.y,
            },
        };
    }
    else {
        return {
            ...signal,
            x: {
                ...x,
                delta: x.originalDelta + shift.x,
            },
            y: {
                ...y,
                delta: y.originalDelta + shift.y,
            },
        };
    }
}
function getZoneAxis(zone, shiftTarget, shift) {
    const { x, y } = zone;
    if (shiftTarget === 'origin') {
        return {
            x: {
                ...x,
                originalFrom: x.from - shift.x,
                originalTo: x.to - shift.x,
            },
            y: {
                ...y,
                originalFrom: y.from - shift.y,
                originalTo: y.to - shift.y,
            },
        };
    }
    else {
        return {
            x: {
                ...x,
                from: (x?.originalFrom || 0) + shift.x,
                to: (x?.originalTo || 0) + shift.x,
            },
            y: {
                ...y,
                from: (y?.originalFrom || 0) + shift.y,
                to: (y?.originalTo || 0) + shift.y,
            },
        };
    }
}
function getPeak(peak, shiftTarget, shift) {
    const { x, y, originalX = 0, originalY = 0 } = peak;
    if (shiftTarget === 'origin') {
        return {
            ...peak,
            originalX: x - shift.x,
            originalY: y - shift.y,
        };
    }
    else {
        return {
            ...peak,
            x: originalX + shift.x,
            y: originalY + shift.y,
        };
    }
}
export function mapZones(zones, datum, options = {}) {
    const { checkIsExisting = true, shiftTarget = 'origin' } = options;
    const shift = getShift(datum);
    const error = get2DSpectrumErrorValue(datum);
    let _zones = zones;
    if (checkIsExisting) {
        _zones = zones.filter((zone) => !isZoneExists(zone, datum, error));
    }
    return _zones.map((zone) => {
        zone.x = zone.x || { from: 0, to: 0 };
        zone.y = zone.y || { from: 0, to: 0 };
        const signals = zone.signals.map((signal) => {
            const { id, kind } = signal;
            let peaks;
            if (signal?.peaks) {
                peaks = (signal?.peaks || []).map((peak) => {
                    const peakDelta = getPeak(peak, shiftTarget, shift);
                    return {
                        ...peak,
                        ...peakDelta,
                        id: peak?.id || v4(),
                    };
                });
            }
            return {
                ...getSignal(signal, shiftTarget, shift),
                peaks,
                id: id || v4(),
                kind: kind || 'signal',
            };
        });
        return {
            ...zone,
            id: zone.id || v4(),
            ...getZoneAxis(zone, shiftTarget, shift),
            signals,
            kind: zone.kind || DatumKind.signal,
        };
    });
}
//# sourceMappingURL=mapZones.js.map